import { render, staticRenderFns } from "./salesList.vue?vue&type=template&id=831cc136&scoped=true"
import script from "./salesList.vue?vue&type=script&lang=js"
export * from "./salesList.vue?vue&type=script&lang=js"
import style0 from "./salesList.vue?vue&type=style&index=0&id=831cc136&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831cc136",
  null
  
)

export default component.exports